import { render, staticRenderFns } from "./SuspectedLogs.vue?vue&type=template&id=58d6cd1b&scoped=true&"
import script from "./SuspectedLogs.vue?vue&type=script&lang=ts&"
export * from "./SuspectedLogs.vue?vue&type=script&lang=ts&"
import style0 from "./SuspectedLogs.vue?vue&type=style&index=0&id=58d6cd1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6cd1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d6cd1b')) {
      api.createRecord('58d6cd1b', component.options)
    } else {
      api.reload('58d6cd1b', component.options)
    }
    module.hot.accept("./SuspectedLogs.vue?vue&type=template&id=58d6cd1b&scoped=true&", function () {
      api.rerender('58d6cd1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/SuspectedLogs.vue"
export default component.exports